export default __webpack_public_path__ + "static/media/google.d502ae06.svg";